<template>
  <div class="brands-banner">
    <div class="home-banners-box carousel slide" data-ride="carousel" id="brandsBannerCarousel" role="region">
      <div class="carousel-inner" v-if="images.homeBanners.length > 0">
        <div class="item" v-for="(banner, index) in images.homeBanners" :key="index" :class="[index === 0 ? activeClass: '']">
          <img :src="banner">
        </div>
      </div>
      <div class="carousel-inner" v-else>
        <div class="item" v-for="(preview, index) in bannerComponent.previews" :key="preview.index" :class="[index === 0 ? activeClass: '']">
          <img :src="preview.image">
        </div>
      </div>
      <a class="left carousel-control" href="#brandsBannerCarousel" role="button" data-slide="prev">
        <span class="glyphicon glyphicon-chevron-left" aria-hidden="true"></span>
        <span class="sr-only">Previous</span>
      </a>
      <a class="right carousel-control" href="#brandsBannerCarousel" role="button" data-slide="next">
        <span class="glyphicon glyphicon-chevron-right" aria-hidden="true"></span>
        <span class="sr-only">Next</span>
      </a>
    </div>
    <div class="side-image"></div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: ['images'],
  data() {
    return {
      brand: this.$store.state.chosenBrand,
      activeClass: 'active',
      bodyComponents: this.$store.state.bodyComponents
    };
  },
  computed: {
    ...mapGetters(["chosenArray"]),
    bannerComponent() {
      return this.bodyComponents.find(c => c.title === "Default Homepage Banner");
    }
  },
  mounted() {
    (function() {
      var s = {
        init: function() {
          var sideItem = $('.side-image'),
              sideWidth = mainItem.outerWidth(),
              sideHeight = mainItem.height(),
              mainItem = $('#brandsBannerCarousel'),
              sideItems = $('#brandsBannerCarousel .item-img')

          if (mainItem.length) {
            function normalizeWidths() {
              $(mainItem).css('max-width','calc(100% - ' + sideWidth + 'px');
            }
            normalizeWidths();
          };
          if (sideItems.length) {
            function normalizeHeights() {
              sideItem.each(function() {
                  $(this).css('height',sideHeight + 'px');
                  $(this).css('width',sideHeight + 'px');
              });
            };
            normalizeHeights();
          };

          $(window).on('load resize orientationchange', function () {
            normalizeWidths();
            normalizeHeights();
          });
        }
      }
      var c = {
        init: function() {
          $('#brandsBannerCarousel').carousel()
        }
      }
      $(document).ready(s.init);
      $(document).ready(c.init);
    })(jQuery);
  }
};
</script>

<style
  scoped
  src="../../static/bootstrap-3.3.7-dist/css/bootstrap.min.css"
></style>

<style scoped>
  #brandsBannerCarousel .carousel-control {
    width: 5%;
  }
  .brands-banner {
    display: flex;
    cursor: pointer;
  }
  .brands-banner .side-image, #brandsBannerCarousel {
    display: inline-block;
  }
  #brandsBannerCarousel, #brandsBannerCarousel .item-img {
    width: 100%;
  }
  #brandsBannerCarousel .item-img {
    background-size: cover;
  }
  .brands-banner .side-image {
    background-image: url("../../static/images/dg-website-brands-banner-side.png");
    background-size: cover;
    background-position: bottom;
  }
  @media (min-width: 1500px) {
    .brands-banner .side-image {
      min-width: 420px;
    }
  }
  @media (max-width: 1499px) {
    .brands-banner .side-image {
      min-width: 350px;
    }
  }
  @media (max-width: 1199px) {
    .brands-banner .side-image {
      min-width: 280px;
    }
  }
  @media (max-width: 991px) {
    .brands-banner .side-image {
      min-width: 230px;
    }
  }
  @media (max-width: 767px) {
    .brands-banner .side-image {
      min-width: 0px;
    }
  }
</style>
